import { useState } from 'react';
import { CalendarPlusIcon } from 'lucide-react';
import { Panel } from '../ui/Panel';
import { Field } from '../ui/Field';
import { SlotPicker } from '../../ui/SlotPicker';
import { useAdmin } from '../AdminContext';
import { btnSecondary, inputCls } from '../ui/styles';
import { newRequestId } from '../../core/api/http';
import { courseStatus } from '../../utils/account';
import type { CustomerFileControl } from './useCustomerFile';

/** Door Sarah ingepland = direct bevestigd. Hoort het bij de lopende kuur, dan krijgt het het sessienummer mee. */
export function NewAppointment({
  ctl
}: {
  ctl: CustomerFileControl;
}) {
  const {
    catalog,
    index,
    site
  } = useAdmin();
  const status = courseStatus(ctl.file.account);
  const [open, setOpen] = useState(false);
  const [slug, setSlug] = useState(status?.course.treatmentSlug ?? catalog.treatments[0]?.slug ?? '');
  const courseSession = status?.course.treatmentSlug === slug && status.nextToBook || undefined;
  const courseTotal = status?.course.total;
  if (!open) {
    return <button type="button" onClick={() => setOpen(true)} className={btnSecondary} data-id="element-1410" data-mp="3ob0y959slyi1">
        <CalendarPlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1411" data-mp="3t9avrmizpb6t" />
        Afspraak inplannen
      </button>;
  }
  return <Panel title="Afspraak inplannen" description="Door jou ingepland = direct bevestigd. De klant krijgt een bericht." data-id="element-1412" data-mp="1506aunvg49s">
      <Field label="Behandeling" data-id="element-1413" data-mp="35lkwyfqaa20k">
        <select value={slug} onChange={e => setSlug(e.target.value)} className={inputCls} data-id="element-1414" data-mp="35mcl55hjwxgt">
          {catalog.treatments.map(t => <option key={t.slug} value={t.slug} data-id="element-1415" data-mp="39kaaq9f8hlkq">
              {t.name} · {t.durationMinutes} min
            </option>)}
        </select>
      </Field>
      {courseSession && <p className="mt-2 text-[13px] text-muted" data-id="element-1416" data-mp="3jeiykjtbkqck">
          Wordt sessie {courseSession} van {courseTotal} van de kuur.
        </p>}
      <div className="mt-4" data-id="element-1417" data-mp="2qvn6tu8sn28q">
        <SlotPicker hours={site.openingHours} confirmLabel={when => `Inplannen op ${when}`} cancelLabel="Annuleer" onCancel={() => setOpen(false)} onConfirm={async (date, time) => {
        const ok = await ctl.addAppointment({
          requestId: newRequestId(),
          treatmentSlug: slug,
          date,
          time,
          kind: index.treatmentBySlug(slug)?.online ? 'video' : 'salon',
          session: courseSession
        });
        if (ok) setOpen(false);
      }} data-id="element-1418" data-mp="2qukedhvtorqp" />
      </div>
    </Panel>;
}